import { useQuery } from 'react-query';

import { getIsServicePorviderExists } from 'api/clients/getIsServicePorviderExists';

export const useClientCompanyData = () => {
  const { data, refetch, isLoading } = useQuery('clientCompanyData', () => getIsServicePorviderExists(), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading };
};

export default useClientCompanyData;
